import React from 'react';
import {svgIconWrapper} from '../svg-icon-wrapper';
import AlignLeft from './icon-align-left.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <AlignLeft {...validProps} />;
}
SvgComponent.iconName = 'alignLeft';

export const AlignLeftIcon = svgIconWrapper(SvgComponent);
